// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-wrapper[data-v-043c7ec7]{border-radius:45px;left:calc(50% - 45px);position:fixed;top:calc(50% - 45px);z-index:8}.loading-circle[data-v-043c7ec7] svg{background-image:linear-gradient(105deg,#d679c7,#2baee8)!important}.loading-circle[data-v-043c7ec7] svg{border-radius:45px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
